class IpConvert {
    dec2ip(ip) {
        if (ip == 0) return 'never login';
        return ((ip >>> 24) + '.' + (ip >> 16 & 255) + '.' + (ip >> 8 & 255) + '.' + (ip & 255));
    }
    ip2dec(ip) {
        if (ip == 0) return ip;

        return ip.split('.').reduce(function (ipInt, octet) {
            return (ipInt << 8) + parseInt(octet, 10)
        }, 0) >>> 0;
    }
}

export default new IpConvert();